import React, { Component } from 'react'
import PlusIcon_gray from '../assets/img/icon/plus_gray.svg'
import MoveIcon from '../assets/img/icon/move.svg'
import ArrowIcon from '../assets/img/icon/arrow.svg'
import DeleteIcon from '../assets/img/icon/delete.svg'
import CompleteIcon from '../assets/img/icon/check_blue.svg'
import LibraryList from './LibraryList'

class SearchItemTop extends Component {
    constructor(props) {
        super(props);

        this.state = {
            btnShow: false,
            showLibrary: false,
            isNew: props.data.isNew,
        };

    }

    componentDidMount() {

        setTimeout(
            function () {
                this.setState({ isNew: false });
            }
                .bind(this),
            1000
        );

    }

    render() {
        let data = this.props.data;
        let keywordList = this.props.keywordList;

        return (
            <div className="search-item-top" onMouseOver={() => this.setState({ btnShow: true })}
                onMouseLeave={() => this.setState({ btnShow: false, showLibrary: false })}>

                <div className="left-btn-list">
                    {data.condition === "complete" &&
                        <button>
                            <img src={CompleteIcon} />
                        </button>
                    }
                    {(this.state.btnShow && data.condition === "waiting") &&
                        <button className="handle">
                            <img src={MoveIcon} />
                        </button>
                    }

                    {(this.state.btnShow && data.condition !== "complete" && data.condition !== "editable") &&
                        <button onClick={() => this.setState({ showLibrary: !this.state.showLibrary })} className="add-btn">
                            <img src={PlusIcon_gray} />
                            {this.state.showLibrary &&
                                <LibraryList addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                                    data={this.props.data} libraryList={this.props.libraryList} />
                            }
                        </button>
                    }

                </div>

                <h3 className={this.state.isNew ? "new" : data.condition === "editing" || data.condition === "editable" ? "active" : ""}>
                    {this.props.data.type}
                </h3>

                {((data.condition === "complete" || data.condition === "editable") && !this.props.isOpen) &&
                    <ul className="complete-keyword-list">
                        {
                            keywordList.map((v, k) => {
                                let keywordText = v.name ? v.name : v.title ? v.title : v;

                                if (v.keywordDetail && v.keywordDetail.sname && v.keywordDetail.sname.indexOf(" ") > -1) {
                                    v.keywordDetail.sname.replace(' ', '-');
                                }
                                return <li key={k}>
                                    {v.code === 5 ? <a className="underline" href={"https://lib.mimic.us/taxon/search?=" + v.keywordDetail.sname} target="_blank">{keywordText}</a> : keywordText}
                                </li>
                            })
                        }
                    </ul>
                }

                {this.state.btnShow &&
                    <div className="right-btn-list">
                        {(data.condition !== "waiting" && data.condition !== "editing") &&
                            <button onClick={() => this.props.setIsOpen(!this.props.isOpen)}
                                className={this.props.isOpen ? "" : "open"}>
                                <img src={ArrowIcon} />
                            </button>
                        }
                        {data.id != 0 &&
                            <button onClick={() => this.props.deleteItem()}>
                                <img src={DeleteIcon} />
                            </button>
                        }

                    </div>
                }

            </div>
        )
    }
}


export default SearchItemTop;

